<div class="pageheader">
    <div class="page-title">
        <h1>Import/Export Settings</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
          </div>
    </div>
</div>

<form [formGroup]="formGroup" (ngSubmit)="formSubmit()">
    <app-layout-container fluid>
        <app-layout-row>
            <app-layout-column [width]="2" offset="0">
                <app-checkbox decorator="right-side" formControlName="includeArtifacts" caption="Include artifacts in export" infoText=""></app-checkbox>
            </app-layout-column>
        </app-layout-row>


        <app-layout-row>
            <app-layout-column [width]="2" offset="0">
                @if (formGroup.enabled) {
                <app-layout-row margin="">
                    <app-layout-column [width]="6">
                        <app-button primary submit width="100%" [disabled]="!formGroup.valid">Save</app-button>
                    </app-layout-column>
                    <app-layout-column [width]="6">
                        <app-button tertiery width="100%" (buttonClick)="formCancel()">Cancel</app-button>
                    </app-layout-column>
                </app-layout-row>
                } @else {
                    <app-layout-row margin="">
                        <app-layout-column [width]="6">
                            <app-button primary width="100%" (buttonClick)="formEdit()">Edit</app-button>
                        </app-layout-column>
                    </app-layout-row>
                }
            </app-layout-column>
        </app-layout-row>

    </app-layout-container>
</form>
